(function ($) {
    
    function arrowClicks(){
        $('.nav-menu a').on('click',function(e) {
            
            var href = $(this).attr('href');
            
            if (href === '#' && $(this).parent().hasClass('menu-item-has-children')){
                e.preventDefault();
                $( this ).siblings('.sub-menu').addClass('active');
                $( this ).closest('.menu-item').addClass('open');
                $( this ).parent().siblings('.menu-item').addClass('hidden');
            }
        });
        $('.nav-menu li .arrow').on('click',function(e) {
            e.preventDefault();
            $( this ).next().addClass('active');
            $( this ).closest('.menu-item').addClass('open');
            $( this ).parent().siblings('.menu-item').addClass('hidden');
            $( this ).closest('.sub-menu').addClass('parent');
        });
        $('.sidr__menu-back').on('click',function(){
            var menuCloseId = $( this ).data('sidr-menu');
            $( '#' + menuCloseId ).removeClass('active');
            $( '#' + menuCloseId ).parents('.sub-menu').removeClass('parent');
            $( this ).closest('.menu-item').removeClass('open');
            
            $( this ).parent().closest('.menu-item').siblings('.menu-item').removeClass('hidden');
        });
    }
    
    function stickyNav(){
        var $scrollTop = $(window).scrollTop();
        
		if ($scrollTop > 74) { //80 + 57
			$('#masthead').addClass('sticky');
		} else {
			$('#masthead').removeClass('sticky');
		}
	};

	/* Document Ready */
	$(document).ready(function() {
        
        AOS.init({
            duration: 400,
            once: false,
            anchorPlacement: 'top-bottom'
        });
        
        /* Jarallax requirements */
        // object-fit polyfill run
        objectFitImages();

        // init Jarallax
        jarallax(document.querySelectorAll('.jarallax'), {
            disableParallax: /iPhone|iPod|Android/,
        });

        jarallax(document.querySelectorAll('.jarallax-keep-img'), {
            keepImg: true,
        });
        
        
        $('#mobile-trigger').sidr({
            side: 'left',
            name: 'sidr',
            displace: false,
            source : function() {
                var sidrHtml;
                
                sidrHtml = '<section id="mobile-menu">';
                
//                sidrHtml += '<section class="sidr__header">';
//                sidrHtml += '<div class="sidr__logo"><a href="/"><img src="/wp-content/themes/sns-2025/assets/images/global/logo.png" alt="Southern Neurosurgery" width="140" height="58"/></a></div>';
//                sidrHtml += '<button class="sidr__close" aria-label="Close"><span class="screen-reader-text">Close</span></button>';
//                sidrHtml += '</section>';
                
                sidrHtml += '<div class="sidr__inner">';
                sidrHtml += '<nav class="sidr__mainnav" aria-label="Mobile">';
                sidrHtml += '<ul class="nav-menu">';
                    
                if($('.main-navigation').length){
                    sidrHtml += $('.main-navigation .nav-menu').html();
                }
                
                sidrHtml += '</ul>';
                sidrHtml += '</nav>';
                
                if($('#site-header-contact').length){
                    sidrHtml += '<div class="sidr__subnav">';

                    var contactUrl = $('#site-header-contact').attr('href');
                    sidrHtml += '<a href="' + contactUrl + '" class="button button-primary-default" id="sidr__contact">' +  $('#site-header-contact').html() + '</a>';
                    
                    sidrHtml += '</div>';
                }
                
                sidrHtml += '</div>';
                sidrHtml += '</section>';
                    
                return sidrHtml;
            },
            onOpen: function() {
                var headerHeight = $("#masthead").height(),
                    windowHeight = $(window).height();
                
                $('#mobile-trigger').addClass('active');
                $('#masthead').addClass('mobile');
                
                $( '.site-content' ).prepend( '<div class="sidr-overlay"></div>' );
                
                $('.sidr__inner').find('.sub-menu').each(function() {
                    var menuId = $(this).parents('.menu-item').attr('id'),
                        parentLink = $(this).prevAll('a').attr('href'),
                        parentText = $(this).prevAll('a').html();
                    
                    $(this).attr('id','sidr-' + menuId).prepend('<li class="sidr__menu-back" data-sidr-menu="sidr-' + menuId + '">' + parentText + '</li>');
                });
            },
            onOpenEnd: function(){
                arrowClicks();
            },
            onClose: function(){
                $('#mobile-trigger').removeClass('active');
                $( '.sidr-overlay' ).remove();
                $('#masthead').removeClass('mobile');
            },
            onCloseEnd: function(){
                $('.sidr__inner').find('.sub-menu').each(function() {
                    $(this).find('.sidr__menu-back').remove();
                });
            }
        });
        
        $('.sidr__close').click(function() {
            $.sidr('close','sidr');
            $('.nav-menu li .arrow').unbind();
            $('sidr__menu-back').unbind();
            stickyNav();
        });
        
        stickyNav();
        
        
        $( '.js-video-popup' ).magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
        $( '.js-modal-popup' ).magnificPopup({
            type: 'inline',
            preloader: false
        });
	});
    
    $(document).on("mousedown touchstart",function(event){
        if($(event.target).closest('#sitesearch--toggle').length && $(event.target).is('#sitesearch--toggle')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#mobile-search').length && $(event.target).is('#mobile-search')) {
            $('#sitesearch').addClass('active');
            $.sidr('close','sidr');
        }
        if($(event.target).closest('#sitesearch--close').length && $(event.target).is('#sitesearch--close')) {
            $('#sitesearch').removeClass('active');
        }
        if($(event.target).closest('#sitesearch.active').length && $(event.target).is('#sitesearch.active')) {
            $("#sitesearch").removeClass('active');
        } 
    });
    
    //on resize
//    $(window).on('resize', function(){
//        AOS.refresh();
//    });
//    $("#page").on('scroll', function () {
//        AOS.refresh();
//    });
    let samt = 0;
    window.addEventListener('scroll', function() {
        samt <= 10 ? samt++ : AOS.refresh();
        samt <= 10 ? samt++ : stickyNav();
    });

    
})(jQuery);